<template>
    <div id="Appedition" class="app-inner">
            <div class="public-btn-small flex align-cen" style="padding-left:0;margin-bottom:16px">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            <div class="public-btn-small-primary"   style="margin-left:16px"
            @click="openAddeiton(1,$route.query.id,'',$route.query.appType)"
            >
               新增版本
            </div>
            </div>
            <div class="p-tit-c">
                 <div class="businessList-filter">
      <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">版本号：</div>
          <div class="el-select1">
            <el-input placeholder="请输入版本号" v-model="search" clearable> </el-input>
          </div>
         </div>
      </div>
      <div class="businessList-filter-list flex align-cen">
                    <div class="label">发布时间：</div> 
                      <el-date-picker
                            v-model="value2"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="dataSuccess"
                            >
                            </el-date-picker>
                  </div>
                       <div class="businessList-filter-list flex align-cen">
        <div class="label">版本类型：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allRadio"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="searchList" >PC端</el-radio>
        <el-radio v-model="radio" label="2" @change="searchList">移动端</el-radio>
      </div>
            <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="searchList">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
                 </div>
            </div>
            <div class="businessList-container">
              <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  应用名称：{{$route.query.appName}}
            </div>
        </div>
        <!-- 表格 -->
          <div class="businessList-container-table">
                   <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
             >
             <el-table-column prop="versionNum" label="版本号" align="center">
          </el-table-column>
             <el-table-column  label="发布信息" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.message">
                        暂无信息
                    </div>
                    <div v-else >
                        <div v-html="scope.row.message" class="minh"></div>
                    </div>
                </template>
          </el-table-column>
            <el-table-column label="版本类型" align="center">
            <template slot-scope="scope">
                <span>{{scope.row.versionType == 1 ? 'PC端' : '移动端'}}</span>
            </template>
          </el-table-column>
           <el-table-column label="当前版本" align="center">
            <template slot-scope="scope">
                <span>{{scope.row.currentVersion == 1 ? '是' : '否'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" align="center" prop="createTime">
          </el-table-column>
          <el-table-column label="操作" align="center">
             <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="openAddeiton(2,$route.query.id,scope.row.id,$route.query.appType)"
                >查看</el-button
              >
               <el-button
                type="text"
                size="small"
                style="color:red"
                v-if="scope.row.currentVersion == 1 && scope.row.versionNum != '1.0'"
                @click="rebackApp(scope.row)"
                >版本回退</el-button
              >
            </template>
          </el-table-column>
                   </el-table>
                          <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
          </div>
            </div>
    <el-dialog
  title="版本回退"
  :visible.sync="centerDialogVisible"
  width="50%"
  :append-to-body="true"
  center>
   <div class="rebackList">
    <div class="rebackList-head">
    你可选择回退到以下版本，最多保存最近发布或回退的5个版本。请您务必确认您希望回退的版本。回退后，正式环境将替换为选择的版本。
    </div>
                 <el-table
          ref="multipleTable1"
          :data="rebackList"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
             >
         <el-table-column prop="versionNum" label="版本号" align="center">
          </el-table-column>
           <el-table-column label="版本类型" align="center">
            <template slot-scope="scope">
                <span>{{scope.row.versionType == 1 ? 'PC端' : '移动端'}}</span>
            </template>
          </el-table-column>
           <el-table-column  label="发布信息" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.message">
                        暂无信息
                    </div>
                    <div v-else >
                        <div v-html="scope.row.message"></div>
                    </div>
                </template>
          </el-table-column>
            <el-table-column label="操作" align="center">
             <template slot-scope="scope">
                  <el-button
                type="text"
                size="small"
                style="color:red"
                @click="choiceApp(scope.row)"
                >选择</el-button
              >
             </template>
            </el-table-column>
                 </el-table>
   </div>
</el-dialog>
    </div>
</template>
<script>
import {getAppVersionList,ApprebackList,appAllfun} from "@/api/index/index"  //版本列表、回退版本列表、回退版本操作
export default {
    name:'Appedition',
    data() {
        return {
          radio:'',
          value2:'',
          start_time:'',
          end_time:'',
          pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        centerDialogVisible:false,
        search:'',
        list:[],
        totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount: 0,
        pageSizes:[10,20,30,40,50,100],
        rebackList:[]
        }
    },
    created() {
        this.gethisInfo()
    },
    methods: {
      allRadio(){
        this.radio = ''
        this.currentPage = 1
        this.gethisInfo()
      },
      dataSuccess(){
        if(this.value2){
            this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
                this.start_time = ""
                this.end_time = ""
          }
          this.gethisInfo()
      },
        // 打开新增版本
        openAddeiton(type,id,appId,appType){
              this.$router.push({
            name: "addAppediton",
            query:{
                id:id,
                appName:this.$route.query.appName,
                type:type,
                appId:appId,
                appType:appType
            }
           })
        },
        // 打开版本回退弹窗
        rebackApp(data){
            this.centerDialogVisible = true
            this.rebackListFun(data)
        },
        // 版本回退列表
        rebackListFun(data){
                let params = {
                id:this.$route.query.id,
            }
            ApprebackList(params)
            .then(res => {
              this.rebackList = res.data
            })
            .catch(err => {
            })
        },
        // 回退版本操作
        choiceApp(data){
              this.$confirm('此操作将正式环境将替换为选择的版本, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
                appAllfun({id:data.id},'put')
                        .then(res => {
                           if(res.code == 0){
                            this.$message.success('回退成功')
                            this.centerDialogVisible = false
                            this.gethisInfo()
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                        })
        })
        },
           // 获取列表
        gethisInfo(){
            let params = {
                appId:this.$route.query.id,
                versionNum:this.search,
                current: this.currentPage,
                size:this.PageSize,
                startTime:this.start_time,
                endTime:this.end_time,
                versionType:this.radio
            }
            getAppVersionList(params)
            .then(res => {
              this.list = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
           handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
        // 搜索
        searchList(){
            this.currentPage = 1
            this.gethisInfo()
        },
        // 重置
        reset(){
            this.search = ""
            this.radio = ""
            this.start_time = ""
            this.end_time = ""
            this.value2 = ""
            this.currentPage = 1
            this.gethisInfo()
        },
        // 返回
        reback(){
            this.$router.push('/Application')
        },
    },
}
</script>
<style lang="scss" scoped>
#Appedition{
  .minh{
      text-overflow: -o-ellipsis-lastline;
	overflow: hidden;				//溢出内容隐藏
	text-overflow: ellipsis;		//文本溢出部分用省略号表示
	display: -webkit-box;			//特别显示模式
	-webkit-line-clamp: 2;			//行数
	line-clamp: 2;					
	-webkit-box-orient: vertical;	//盒子中内容竖直排列
  }
      .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
  .businessList-container{
    margin-top: 20px;
    .businessList-container-table{
        margin-top: 20px;
    }
    .jiange {
      margin-top: 20px;
    }
  }
}
::v-deep{
        .el-dialog{
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
}
</style>